<template>
  <div class="stage-card-info-list">
    <div class="header grey--text text--darken-2">
      <slot name="header"></slot>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'StageCardInfoList',
};
</script>

<style lang="scss" scoped>
.stage-card-info-list {
  display: grid;
  gap: 16px;

  .header {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
